// extracted by mini-css-extract-plugin
export default {"starsWrapper":"ratingStar_starsWrapper__IuYfb","star":"ratingStar_star__F9TQY"};